import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import TeamImg from "../../assets/images/login-bg.jpg";
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";
import TablePagination from "../../commons/Pagination/TablePagination";

function UsersNotification() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  // const [totalPages, setTotalPages] = useState(1);

  // Reset page to 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [search]);

  const location = useLocation();
  const { notification } = location.state || {};
  const receivers = notification?.receiverDetails || [];

  // Filter receivers by search including role
  const filteredData = receivers.filter(user => {
    const roleName = user?.role?.role?.toLowerCase() === "user" ? "customer" : user?.role?.role?.toLowerCase() || "";
    return (
      user.full_name?.toLowerCase().includes(search.toLowerCase()) ||
      user.email?.toLowerCase().includes(search.toLowerCase()) ||
      user.phone?.toLowerCase().includes(search.toLowerCase()) ||
      roleName.includes(search.toLowerCase())
    );
  });
  const totalPages = Math.ceil(filteredData.length / limit); // update total pages
  const paginatedData = filteredData.slice((page - 1) * limit, page * limit);

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.USERS}</h3>
            </div>
            <div className="mb-3">
              <button
                type="button"
                className="btn btn-default rounded-lg"
                onClick={() => navigate(UI_CONSTANTS.ROUTES.NOTIFICATION_LIST)}
              >
                Back
              </button>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80" class="text-center">
                          {UI_CONSTANTS.TABLE_HEADERS.ID}
                        </th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.NAME}</th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.EMAIL}</th>
                        <th width="150px">{UI_CONSTANTS.TABLE_HEADERS.MOBILE_NUMBER}</th>
                        <th>Role</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                            </div>
                          </td>
                        </tr>
                      ) :  paginatedData.length > 0 ? (
                            paginatedData.map((user, index) => (
                            <tr key={user._id || index}>
                                <td>{index + 1}</td>
                                <td className="text-center">{user.full_name || "N/A"}</td>
                                <td className="text-center">{user.email || "N/A"}</td>
                                <td className="text-center">{user.phone || "N/A"}</td>
                                <td className="text-center">{user?.role?.role?.toLowerCase() === "user" ? "Customer" : user?.role?.role || "N/A"}</td>
                            </tr>
                            ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsersNotification;
